import { ApolloClient, gql, NormalizedCacheObject, useQuery } from "@apollo/client";
import { Agent, Query } from "../types/generated/graphql";

export const useGetAllAgents = (client: ApolloClient<NormalizedCacheObject>) => {
  type T = Pick<Query, 'getAgents'>;
  
  const { data, loading, error } = useQuery<T>(QUERY_GET_AGENTS, {
    client,
    fetchPolicy: "network-only", // Always fetch from the server
  });

  return { data, loading, error };
};

// GraphQL query to fetch all agents from the server
const QUERY_GET_AGENTS = gql`
  query getAgents {
    getAgents {
      version
      name
      specialization
      description
      thumbnails {
        url
        width
        height
      }
      min_age
      max_age
      data_requirement
      type
    }
  }
`;